var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPowerbiDark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 24,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#powerbiDark_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#CAC9C9",
  d: "M18 1.001V23c0 .553-.448 1.001-1.001 1.001H10.75a1 1 0 0 1-1.001-1.001V1C9.75.448 10.198 0 10.751 0H17C17.552 0 18 .448 18 1.001"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E9E7E7",
  d: "M13.125 7v17h-8.25V7a1 1 0 0 1 1-1h6.25a1 1 0 0 1 1 1"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBFBFB",
  d: "M0 13v10a1 1 0 0 0 1 1h7.25V13a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "powerbiDark_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h18v24H0z"
})))));
export { SvgPowerbiDark as ReactComponent };
export default __webpack_public_path__ + "static/media/powerbiDark.129bb672.svg";